import React from 'react';
interface TornEdgeProps {
  /** Clase de color de fondo de la sección que "rasga" la anterior. */
  colorClassName: string;
}
export function TornEdge({
  colorClassName
}: TornEdgeProps) {
  return <div aria-hidden="true" className={`edge-torn pointer-events-none absolute inset-x-0 -top-3 h-3 ${colorClassName}`} data-id="element-208" data-mp="1fxvkiduv12as" />;
}